import { FC, useRef } from 'react';

import { useDisclosure } from '@bonusly/design-system';
import { useEventListener } from '@bonusly/events';

import { User } from '../../lib';
import { FeedbackEvent } from '../../types/feedback-event';
import { useFeedbackModalProps } from '../request-feedback/hooks/use-feedback-modal-props';
import { GiveUnrequestedFeedbackModal } from './give-unrequested-feedback-modal';

type ReferenceData = {
	defaultUsers?: User[];
	reference?: any;
};

export const GlobalGiveUnrequestedFeedbackModal: FC = () => {
	const modal = useDisclosure();
	const referenceRef = useRef<ReferenceData>({});
	const { defaultUsers, reference } = useFeedbackModalProps(referenceRef.current);

	useEventListener(FeedbackEvent.OpenUnsolicited, (data?: ReferenceData) => {
		if (data) {
			referenceRef.current = data;
		}
		modal.onOpen();
	});

	return <GiveUnrequestedFeedbackModal defaultRecipients={defaultUsers} reference={reference} {...modal} />;
};
